"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiringProcessColumn = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_breakpoints_1 = require("styled-breakpoints");
const react_styled_1 = require("styled-breakpoints/react-styled");
const react_intl_1 = require("react-intl");
const react_use_1 = require("react-use");
const HiringProcessCard_1 = require("./HiringProcessCard");
const HiringProcessColumns_style_1 = require("./HiringProcessColumns.style");
const mergeRefs = (...refs) => {
    const filteredRefs = refs.filter(Boolean);
    if (!filteredRefs.length)
        return null;
    if (filteredRefs.length === 0)
        return filteredRefs[0];
    return inst => {
        // eslint-disable-next-line no-restricted-syntax
        for (const ref of filteredRefs) {
            if (typeof ref === 'function') {
                ref(inst);
            }
            else if (ref) {
                ref.current = inst;
            }
        }
    };
};
const Card = ({ application, index, selectedApplications, setApplicationDetail, onCardSelected, isHiringProcessActive, selectedCount, draggingCardId, isDragging, }) => {
    const isCardSelected = Boolean(selectedApplications.find(app => app.id === application.id));
    const isGhosting = isCardSelected && isDragging && draggingCardId !== application.id;
    return ((0, jsx_runtime_1.jsx)(HiringProcessCard_1.HiringProcessCard, { application: application, onOpenDetailClick: app => setApplicationDetail(app), onCardSelected: onCardSelected, isCardSelected: isCardSelected, isDragDisabled: !isHiringProcessActive, index: index, selectedCount: selectedCount, isGhosting: isGhosting }, application.id));
};
const ApplicationCard = react_1.default.memo(Card);
const HiringProcessColumn = ({ columnType, isDragging, applicationGroups, isHiringProcessActive, selectedApplications, onCardSelected, selectedCount, setApplicationDetail, draggingCardId, snapshot, provided, isHalfSize, }) => {
    const [shadows, setShadows] = react_1.default.useState({
        bottom: false,
        right: false,
        left: false,
    });
    const scrollRef = react_1.default.useRef(null);
    const { x, y } = (0, react_use_1.useScroll)(scrollRef);
    const isBelowLg = (0, react_styled_1.useBreakpoint)((0, styled_breakpoints_1.down)('lg'));
    function setColumnShadow() {
        const column = document.getElementById(columnType);
        if (!column) {
            return;
        }
        const scroll = isBelowLg ? x : y;
        const maxScrollValue = isBelowLg
            ? column.scrollWidth - column.clientWidth
            : column.scrollHeight - column.clientHeight;
        const isScrollable = isBelowLg
            ? column.scrollWidth > column.clientWidth
            : column.scrollHeight > column.clientHeight;
        if (!isScrollable) {
            setShadows({
                bottom: false,
                right: false,
                left: false,
            });
        }
        if (scroll === 0 && isScrollable) {
            setShadows({
                bottom: true,
                right: true,
                left: false,
            });
        }
        if (scroll >= maxScrollValue - 10 && isScrollable) {
            setShadows({
                bottom: false,
                right: false,
                left: true,
            });
        }
        if (scroll !== 0 && Math.abs(scroll - maxScrollValue) > 2 && isScrollable) {
            setShadows({
                bottom: true,
                right: true,
                left: true,
            });
        }
    }
    react_1.default.useEffect(() => {
        setColumnShadow();
    }, [y, x, isBelowLg, isDragging]);
    return ((0, jsx_runtime_1.jsx)(HiringProcessColumns_style_1.ShadowWrap, { children: (0, jsx_runtime_1.jsxs)(HiringProcessColumns_style_1.Column, { id: `${columnType}`, isDragging: isDragging, isDraggingOver: snapshot.isDraggingOver, isHiringProcessActive: isHiringProcessActive, ref: mergeRefs(provided.innerRef, scrollRef), ...provided.droppableProps, isHalfSize: isHalfSize, showBottomShadow: shadows.bottom, showLeftShadow: shadows.left, showRightShadow: shadows.right, children: [(0, jsx_runtime_1.jsx)(HiringProcessColumns_style_1.ColumnTitle, { isDragging: isDragging, isDraggingOver: snapshot.isDraggingOver, children: (0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: `offer_application.stage.${columnType}` }), " (", applicationGroups[columnType].length, ")"] }) }), (0, jsx_runtime_1.jsxs)(HiringProcessColumns_style_1.CardsWrap, { children: [applicationGroups[columnType].map((application, index) => ((0, jsx_runtime_1.jsx)(ApplicationCard, { application: application, index: index, selectedApplications: selectedApplications, setApplicationDetail: setApplicationDetail, onCardSelected: onCardSelected, isHiringProcessActive: isHiringProcessActive, selectedCount: selectedCount, isDragging: isDragging, draggingCardId: draggingCardId }, application.id))), provided.placeholder] })] }) }));
};
exports.HiringProcessColumn = HiringProcessColumn;
